import React from 'react'
import { Container, Paragraph, Logo, Icon } from '@scentregroup/ui'
import ExternalLink from '../external-link'
import analyticsUtils from '../../helpers/analytics-utils'
import style from './index.scss'

interface NationalHeaderProps {
  promotionalUrl: string
}

const NationalHeader: React.FunctionComponent<NationalHeaderProps> = ({
  promotionalUrl,
}) => (
  <Container className={style.logoWrap} type="large">
    <Logo className={style.logo} />
    <div className={style.ctaWrapper}>
      <ExternalLink
        url={promotionalUrl}
        eventCategory={analyticsUtils.categories.GIFTCARD_CLICK}
        eventAction={analyticsUtils.actions.GIFTCARD_NAT_HOME_TEXT}
        rel="noopener"
        target="_self"
      >
        <span data-test-id="gift-cards-link">
          <Icon type="gift-cards" className={style.icon} />
          <Paragraph className={style.linkText}>Gift Cards</Paragraph>
        </span>
      </ExternalLink>
    </div>
  </Container>
)

export default NationalHeader
